import React from 'react';

const AccelByteLogoSquare = () => {
  return (
    React.createElement('svg', {
      width: "21",
      height: "20",
      viewBox: "0 0 21 20"   ,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",}
    
      , React.createElement('path', { d: "M0.333496 0V20L18.3189 16V0H0.333496Z"  , fill: "#0B6CFF",} )
      , React.createElement('path', {
        d: "M5.77523 10.5455L4.64538 12.9546H3.33105L8.01188 2.95456L12.6696 12.9546H11.3553L10.2485 10.5455H5.77523ZM7.98882 5.54547L6.28251 9.43183H9.76431L7.98882 5.54547Z"        ,
        fill: "#EDEDED",}
      )
      , React.createElement('path', {
        d: "M10.6864 4.0682H11.0323C11.5626 4.0682 12.0468 4.11365 12.4158 4.29547H14.0529C13.4765 3.22729 12.093 2.95456 10.6634 2.95456H8.54199L9.14151 4.29547H10.6634V4.0682H10.6864Z"            ,
        fill: "#EDEDED",}
      )
      , React.createElement('path', {
        d: "M10.6865 6.02273V4.68182H9.34912L9.97169 6.02273H10.6865Z"  ,
        fill: "#EDEDED",}
      )
      , React.createElement('path', {
        d: "M13.1537 6.02273H14.3296C14.3527 5.9091 14.3527 5.79546 14.3527 5.70455C14.3527 5.31819 14.3066 4.97728 14.1913 4.68182H12.877C13.0614 4.93182 13.1537 5.25001 13.1537 5.70455C13.1998 5.81819 13.1767 5.93183 13.1537 6.02273Z"                     ,
        fill: "#EDEDED",}
      )
      , React.createElement('path', {
        d: "M13.7533 7.75C13.615 7.68182 13.4766 7.65909 13.3152 7.61363V7.59091C13.7764 7.36363 14.1223 6.90909 14.2837 6.40909H13.1308C12.8541 7.20454 12.024 7.38636 11.0325 7.38636H10.7096V6.40909H10.1562L10.7558 7.75H13.7533Z"                 ,
        fill: "#EDEDED",}
      )
      , React.createElement('path', {
        d: "M10.9404 8.15909H14.3992C14.8142 8.5 15.0909 8.97727 15.2293 9.5H13.9611C13.6152 8.59091 12.4392 8.38636 11.4708 8.38636H11.0557L10.9404 8.15909Z"            ,
        fill: "#EDEDED",}
      )
      , React.createElement('path', {
        d: "M13.6611 11.2046H15.1138C15.2522 10.9091 15.3213 10.5455 15.3213 10.1364C15.3213 10.0455 15.2983 9.95456 15.2983 9.86365H14.0531C14.0762 9.93183 14.0762 10 14.0762 10.0455C14.0762 10.5909 13.9148 10.9546 13.6611 11.2046Z"                     ,
        fill: "#EDEDED",}
      )
      , React.createElement('path', {
        d: "M13.0156 11.6136C12.8773 11.6591 12.7389 11.7046 12.6006 11.75L13.0848 12.7955C13.8457 12.6136 14.5144 12.2273 14.9064 11.6136H13.0156Z"            ,
        fill: "#EDEDED",}
      )
    )
  );
};

export default AccelByteLogoSquare;
